import { Component } from '@angular/core';
import { TranslateDirective } from '../shared/translate.directive';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorComponent } from '../shared/error/error.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [TranslateDirective, CommonModule, FormsModule, ErrorComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.less'
})
export class ForgotPasswordComponent {
  forgotPassModel:any={
    Email: "",
  }
  successfulReg=false;
  hasErrors=false;
  errors:any;
  constructor(private service: LoginService, private router: Router){}

  ngOnInit(){}

  forgotPassword(){
    this.successfulReg = false;
    this.hasErrors = false;
    this.errors = null;

    this.service.forgotPassword(this.forgotPassModel).subscribe({
      next: res =>{
        if(res) {
          this.successfulReg=true;
          this.hasErrors = false;
          this.errors = null;
        }
      },
      error: err=>{      
        this.hasErrors=true;
        this.errors=err?.error?.errors || err?.error || err;
      }
    })

  }

  redirect(){
    this.router.navigate(['/login']);
  }
}
